import React, { useEffect } from "react";
import classNames from "classnames";
import { BemHelper } from "../../utils/BemHelper";
import { useBreakpointValue } from "../../utils";
import { truncateHtmlToPlainText } from "../../utils/stringHelpers";
import defaultImage from "./images/default-product.jpeg";
import { CalendarIcon } from "@/icons/primary";
import { CtImage } from "../../theming";

type Props = {
  title: string;
  createDate: string;
  description?: string;
  image?: string;
  actions?: React.ReactNode;
  onClick?: () => void;
  small?: boolean;
};

const bem = new BemHelper("article-card");

export const ArticleCard: React.FC<Props> = ({
  title,
  createDate,
  description,
  image,
  actions,
  onClick,
  small,
}) => {
  const isMobile = useBreakpointValue({ base: false, xs: true });
  const [date, setDate] = React.useState<string | null>(null);

  // fix for production env
  useEffect(() => {
    setDate(createDate);
  }, [createDate]);

  return (
    <div
      onClick={() => onClick && onClick()}
      className={classNames(
        bem.block(),
        small && bem.modifier("small"),
        onClick && bem.modifier("has-actions"),
      )}
    >
      <CtImage src={image || defaultImage} alt={title} square width={small ? 130 : 180} />

      <div
        className={classNames(
          bem.element("content"),
          small && bem.modifier("small", "content"),
          isMobile && bem.modifier("mobile-content"),
        )}
      >
        <h3
          className={classNames(
            bem.element("title"),
            small && bem.modifier("small", "title"),
            actions && bem.modifier("short", "title"),
            isMobile && bem.modifier("mobile", "title"),
          )}
        >
          {title}
        </h3>

        <div
          className={classNames(
            bem.element("create-date"),
            small && bem.modifier("small", "create-date"),
          )}
        >
          <CalendarIcon style={{ fontSize: small ? "16px" : "18px" }} />
          {date}
        </div>

        {!isMobile && !small && description && (
          <div
            className={classNames(bem.element("description"))}
            dangerouslySetInnerHTML={{ __html: truncateHtmlToPlainText(description, 120) }}
          />
        )}
      </div>

      {actions && <div className={classNames(bem.element("actions"))}>{actions}</div>}
    </div>
  );
};
